// ***************************************
// flowController
//
//This object controls the flow for a standard game.
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 2-11-2015
// ***************************************
import { AIController } from "../../game_logic/code/AIController";
import { AngryAnalytics } from "../../game_logic/code/Analytics/Analytics";
import { AngryLobbyLoader } from "../../game_logic/code/LobbyCode/AngryLobbyLoader";
import { CustomMessageController } from "../../game_logic/code/CustomMessageController";
import { DailyRewardManager } from "../../game_logic/code/DailyRewardManager";
import { ExpManager } from "../../game_logic/code/ExpManager";
import { FriendManager } from "../../game_logic/code/FriendManager";
import { InventoryController } from "../../game_logic/code/InventoryController";
import { InviteFriendManager } from "../../game_logic/code/InviteFriendManager";
import { LevelRandomiser } from "../../game_logic/code/LevelRandomiser";
import { DailyRewardDialog } from "../../game_logic/code/LobbyCode/DailyRewardDialog";
import { NudgeFactory } from "../../game_logic/code/NudgeFactory";
import { ProfileManager } from "../../game_logic/code/ProfileManager";
import { GameController } from "../../game_logic/code/gameController";
import { PowerUpSettings } from "../../game_logic/settings/Settings";
import { ThemeController } from "../code/themeController";
import { tgfSettingsOverride as demoSettings } from "../flow_Demo/env_settings";
import { tgfSettingsOverride as prodSettings } from "../flow_Prod/env_settings";
import { tgfSettingsOverride as devSettings } from "../flow_dev/env_settings";
import { TimeCalculator } from "../timeCalculator/TimeCalculator";
import { _version } from "../version/version";
import { flowSettings } from "./flowSettings";
import { tbGame } from "../../game_logic/engine/tbGame";
import { tgfFramework } from "../../game_logic/framework/tgfFramework";
import { tgfFunctions } from "../../game_logic/framework/tgfFunctions";
import { tgfGraphics } from "../../game_logic/framework/tgfGraphics";
import { tgfSettings } from "../../game_logic/framework/tgfSettings";
import { tgfDictionary } from "../../game_logic/framework/tgfDictionary";
import { tgfHooks } from "../../game_logic/framework/hooks/hooks";
import { YoutubeStorageManager } from "../../game_logic/code/storage/YoutubeStorageManager";
import { youtubeMuteManager } from "../../game_logic/code/YoutubeMuteManager";
// Directives for jslint
/*global tbGame, tbGraphics, tbKeyCodes, tbLoader */
/*global tgfHooks, tgfFunctions, tgfDialogs, tgfComponents, tgfStatus, tgfDictionary, tgfGraphics, tgfAudio, tgfSettings, tgfAnalytics, tgfFramework */
/*global flowSettings, GameController, ThemeController, ClientController, playController */
/*global document */
// ***************************************
// Global variables created by the flow controller
// ***************************************
export var gameController = null; // Object controlling the game
export var themeController = null; // Object controlling the theme
export var inventoryController = null; // The inventory controller
export var levelRandomiser = null; // The inventory controller
export var instantNotificationsService = null; // Service to schedule notifications on instant games
export var profileManager = null; // Holds information of the users (image, name);
// export var AnalyticsService = null;                // Service to send analytics
// export var leaderboardService = null;
// export var leaderboardManager = null;
export var customMessagecontroller = null;
export var inviteFriendManager = null;
export var _enableMaintenance = null; // Creating a variable to make sure the game doesn't crash
export var _currentFlowState = null;
export var _cheatsEnabled = false;
export var rovioUsageLink = "https://cloud.rovio.com/privacyweb/index.html?locale=en&appId=xxx&token=yyy";
// ***************************************
// The constructor for this flow token
// ***************************************
// The constructor for the FlowController game token. 
export var FlowController = function () {
    "use strict";
    // Properties used by the engine
    this.depth = 0;
    this.layer = 10000000; // Below everything else
    this.visible = false;
    this.active = true;
    this.adTimer = -1;
    // Own properties
    this.paused = 0; // Whether the flow is paused (by a hook)
    this.currentAction = this.actionBeforeInitializing; // Current action to be performed
    this.firstTimeMitigation = false; // Fix for startGameASync so the game doesn't start while waiting for FB popup to close
    this.adErrorCount = 0;
    this.initStates = {
        analytics: false,
        inventory: false,
        backend: false,
        tgFramework: false,
        levelRandomiser: false,
        friendManager: false,
        expManager: false,
    };
    // Add it to the game engine
    tbGame.addToken(this);
};
FlowController.adTypes = {
    REWARDED: "REWARDED",
    INTERSTITIAL: "INTERSTITIAL"
};
// This action is done before initialization happens
FlowController.prototype.actionBeforeInitializing = function () {
    "use strict";
    var siteLocks, timeLock;
    document.getElementsByClassName("logger-root").item(0).remove();
    TimeCalculator.markStart("total");
    TimeCalculator.markStart("loader_done");
    TimeCalculator.markStart("tgfFramework");
    // Initialize the flow settings
    tgfSettings.mergeSettings(flowSettings());
    //Overwrite the fbSettings
    switch (true) {
        case DEV:
            devSettings();
            break;
        case PROD:
            prodSettings();
            break;
        case MOCK:
            demoSettings();
            break;
    }
    flowController.isOffline = false;
    // Create the game and theme controllers. These will merge their own settings in.
    gameController = new GameController();
    themeController = new ThemeController();
    _cheatsEnabled = (tgfSettings.environment == "DEV" || tgfSettings.environment === "DEMO");
    // var nakamaBackend = new NakamaBackendProvider(tgfSettings.nakama.key, {
    // 	host: tgfSettings.nakama.endpoint,
    // 	useSSL: true,
    // 	connectivity: {
    // 		autoReconnect: false
    // 	},
    // 	rpcTimeOut: 10000
    // });
    // var nakamaSDK = new MockNakamaSDK("Unknown", {simulateNetworkDelay: true, networkDelayMin: 50, networkDelayMax: 150}, {});
    // var shimSDK = { provider: nakamaBackend, sdk: nakamaSDK };
    // gamesBackendService = new GameSparksBackendService(shimSDK);
    // var imagesPublisher = new ImagesPublisherService(tgfSettings.gamebot.appId, {
    // 	// Endpoints taken from the old Uno images publisher service
    // 	stageEndPoint: "https://imageuploader.facebook.stage.uno.one/production/upload",
    // 	prodEndPoint: "https://imageuploader.facebook.live.uno.one/production/upload"
    // }, tgfSettings.nakama.isProdVersion);
    // instantNotificationsService = new GameSparksInstantNotificationsService(gamesBackendService, tgfSettings.nakama.fbAppToken, imagesPublisher);
    // Initialize the hooks and deal with client settings
    tgfHooks.initialize();
    if (tgfSettings.client.analyticsTracking !== undefined) {
        tgfSettings.framework.initAnalytics = tgfSettings.client.analyticsTracking;
    }
    if (tgfSettings.client.initialLanguage !== undefined) {
        tgfSettings.dictionary.initialLanguage = tgfSettings.client.initialLanguage;
    }
    if (tgfSettings.client.availableLanguages !== undefined) {
        tgfSettings.dictionary.languages = tgfSettings.client.availableLanguages;
    }
    if (tgfSettings.client.splashScreenImage !== undefined) {
        tgfSettings.splashScreenDialogProperties.image = tgfSettings.client.splashScreenImage;
    }
    if (tgfSettings.client.splashScreenColor !== undefined) {
        tgfSettings.splashScreenDialogProperties.color = tgfSettings.client.splashScreenColor;
    }
    if (tgfSettings.client.splashScreenDuration !== undefined) {
        tgfSettings.splashScreenDialogProperties.duration = tgfSettings.client.splashScreenDuration;
        tgfSettings.flow.showSplashScreenDialog = true;
    }
    // Check for site locks
    // siteLocks = tgfHooks.execute("getSiteLocks");
    // if (siteLocks === undefined) {
    //   if (testMode) {
    // 	  console.log("Warning: Check this out!!!");
    //   } else {
    // 	  this.currentAction = undefined;
    // 	  return;
    //   }
    // } else if (!tgfFunctions.checkSiteLocks(siteLocks)) {
    //   this.currentAction = undefined;
    //   return;
    // }
    // // Check for time lock
    // timeLock = tgfHooks.execute("getTimeLock");
    // if (timeLock !== undefined || !tgfFunctions.checkTimeLock(timeLock)) {
    //   this.currentAction = undefined;
    //   return;
    // }
    // TODO: Handle the other client settings
    // Change the document title if it is specified in the game
    if (tgfSettings.game.documentTitle) {
        document.title = tgfSettings.game.documentTitle;
    }
    // Continue to the next action 
    // tgfHooks.execute("beforeInitializing");
    this.currentAction = this.actionInitializing;
};
// This action is done once in the first step only to initialize stuff
FlowController.prototype.actionInitializing = function () {
    "use strict";
    var self = this;
    // Initialize the framework
    tgfFramework.initialize(tgfSettings.framework);
    tgfGraphics.setBackgroundColor("black");
    // tgfAds.initialize(tgfSettings.tgfAdsProperties);
    //FIREBASE INIT TEST // TODO -- check if it's needed or can be removed
    // tgfFirebase.initialize(tgfSettings.tgfFirebaseProperties);
    var timeout;
    timeout = setInterval(function () {
        if (!tgfFramework.initComplete) {
            return;
        } // Wait until the framework is completely loaded
        clearInterval(timeout);
        tgfHooks.execute("afterInitializing");
        TimeCalculator.markStart("sdk_initialized");
        self.initStates.tgFramework = true;
        TimeCalculator.markEnd("tgfFramework");
    }, 50);
    // Continue to the next action 
    this.currentAction = this.actionWaitForFacebookInitializationToFinish;
};
FlowController.prototype.actionWaitForFacebookInitializationToFinish = function () {
    "use strict";
    // if (!fbInstant.initialized) { return; }         // Wait until the framework is completely loaded
    TimeCalculator.markEnd("sdk_initialized");
    var self = this;
    this.playerID = tgfHooks.getPlayerID();
    // leaderboardService = new GameSparksLeaderboardService(gamesBackendService);
    this.currentAction = this.actionInitializeCanvas;
};
FlowController.prototype.actionInitializeCanvas = function () {
    "use strict";
    this.canvas = tgfGraphics.mainCanvas; // Can only be done now that initialization is ready
    this.visible = true;
    // Now start the loading of the resources
    this.currentAction = this.actionStartLoadingResources;
};
// TODO: Deal with advertisements
// Start the loading of the resources, showing the load dialog when required
FlowController.prototype.actionStartLoadingResources = function () {
    "use strict";
    var self = this;
    // init leaderboard manager
    // leaderboardManager = new LeaderboardManager(leaderboardService);
    // Start the actual loading
    TimeCalculator.markStart("actionStartLoadingResources");
    tgfFunctions.loadStart({
        moments: tgfSettings.flow.loadMoments,
        required: tgfSettings.flow.loadRequired,
        minTime: tgfSettings.flow.loadMinTime,
        maxTime: tgfSettings.flow.loadMaxTime
    });
    this._assetLoadStartedTime = Date.now();
    // Show the load screen dialog if required
    if (tgfSettings.flow.showLoadScreenDialog) {
        if (tgfSettings.flow.loadScreenDialog) {
            this.loadScreenDialog = new tgfSettings.flow.loadScreenDialog();
        }
        else {
            // 			this.loadScreenDialog = new tgfDialogs.LoadScreen();
        }
        this.loadScreenDialog.progressFunction = tgfFunctions.loadPercentage;
        this.loadScreenDialog.onHide = function (dialog) { self.loadScreenDialog = undefined; };
        this.loadScreenDialog.show();
    }
    else {
        this.loadScreenDialog = undefined;
    }
    this.currentAction = this.actionWaitForLoadingToFinish;
};
// This action is performed while waiting for the loading of the resources when there is no loading dialog
FlowController.prototype.actionWaitForLoadingToFinish = function () {
    "use strict";
    var self = this;
    tgfHooks.execute("loadingProgress", tgfFunctions.loadPercentage());
    // Check whether the resources are loaded
    if (!tgfFunctions.loadComplete()) {
        return;
    }
    // Check whether the load screen dialog is gone
    if (this.loadScreenDialog) {
        return;
    }
    TimeCalculator.markEnd("actionStartLoadingResources");
    TimeCalculator.markEnd("loader_done");
    TimeCalculator.markStart("loadingFinished");
    var languageString = this.getCorrectLocale(tgfHooks.getLocale());
    tgfDictionary.setLanguage(languageString);
    // Start the title screen
    TimeCalculator.markStart("startGameAsync");
    // tgfHooks.setStartCallback(function(){
    // });
    tgfHooks.execute("afterLoading");
    // this.currentAction = undefined;
    self.currentAction = self.initGameSparks;
};
FlowController.prototype.initGameSparks = function () {
    var self = this;
    this.currentAction = null;
    tgfHooks.logEvent("version", 0, { "version_number": _version });
    // initializing the inventory controller
    TimeCalculator.markStart("inventoryController");
    inventoryController = new InventoryController(PowerUpSettings);
    inventoryController.initialize(function () {
        console.log("Inventory initialized");
        self.initStates.inventory = true;
        TimeCalculator.markEnd("inventoryController");
    });
    // initializing the level randomiser
    TimeCalculator.markStart("levelRandomizer");
    levelRandomiser = new LevelRandomiser();
    levelRandomiser.initialize(function () {
        console.log("Level randomiser initialized");
        self.initStates.levelRandomiser = true;
        TimeCalculator.markEnd("levelRandomizer");
    });
    FriendManager.initialize().then(function () {
        self.initStates.friendManager = true;
        ExpManager.initialize().then(function () {
            self.initStates.expManager = true;
        });
    });
    YoutubeStorageManager.getPlayerData([PowerUpSettings.mightyScopeServerTag, "shortcutRequestCount", "inviteFriends"], function (data) {
        gameController.mightyScopeEnd = data[PowerUpSettings.mightyScopeServerTag] || 0;
        //Invited friends init
        inviteFriendManager = new InviteFriendManager(data);
        var count = data["shortcutRequestCount"] || 0;
        if (true) { // This logic is left in for if we want to tweak it again later
            self.shouldShowShortcutRequestNextMatch = true;
        }
        else {
            count++;
        }
        YoutubeStorageManager.savePlayerData(["shortcutRequestCount"], [count], function () {
            console.log("saved shortcut creation requests: " + count);
        }, function (error) {
            console.log(error);
        });
        self.hasPlayedBefore = !self.firstTimeUser;
    });
    self._serverTimeDiff = 0;
    DailyRewardManager.initialize();
    AIController.getPlayerData();
    self.currentAction = self.waitForPromise;
};
FlowController.prototype.waitForPromise = function () {
    "use strict";
    var self = this;
    profileManager = new ProfileManager();
    profileManager.loadImage(this.playerID, tgfHooks.getPlayerImageUrl());
    profileManager.setName(this.playerID, tgfHooks.getPlayerName());
    AIController.initialize();
    TimeCalculator.markEnd("startGameAsync");
    this.currentAction = this.actionAfterLoading;
};
FlowController.prototype.getCorrectLocale = function (loc) {
    var languageString = loc.replace(/_/, "-");
    switch (languageString) {
        case "en-us":
        case "en-gb":
        case "nl-nl":
        case "fr-fr":
        case "it-it":
        case "de-de":
        case "es-es":
        case "tr-tr":
        case "id-id":
        case "vi-vi":
        case "th-th":
        case "pt-br":
        case "pl-pl":
            break;
        default:
            if (languageString.startsWith("nl-"))
                languageString = "nl-nl";
            else if (languageString.startsWith("fr-"))
                languageString = "fr-fr";
            else if (languageString.startsWith("it-"))
                languageString = "it-it";
            else if (languageString.startsWith("de-"))
                languageString = "de-de";
            else if (languageString.startsWith("es-"))
                languageString = "es-es";
            else if (languageString.startsWith("tr-"))
                languageString = "tr-tr";
            else if (languageString.startsWith("id-"))
                languageString = "id-id";
            else if (languageString.startsWith("in-"))
                languageString = "id-id";
            else if (languageString.startsWith("vi-"))
                languageString = "vi-vi";
            else if (languageString.startsWith("th-"))
                languageString = "th-th";
            else if (languageString.startsWith("pl-"))
                languageString = "pl-pl";
            else if (languageString.startsWith("pt-"))
                languageString = "pt-br";
            else
                languageString = "en-us";
            break;
    }
    return languageString;
};
// This action is performed after the loading is completed (hence, only once)
FlowController.prototype.actionAfterLoading = function () {
    "use strict";
    // Apply a hack to clear browser back buffer on Android stock browser
    // at this moment again because too early is not effective
    tgfGraphics.performBufferClearHack();
    customMessagecontroller = new CustomMessageController();
    // Now go to the title screen
    //this.currentAction = this.actionShowTitleScreen;
    //Go to Ad Dialog
    this.currentAction = this.actionShowSplashScreen;
};
// This action shows the splash screen, if any
FlowController.prototype.actionShowSplashScreen = function () {
    "use strict";
    var self = this;
    if (tgfSettings.flow.showSplashScreenDialog) {
        if (tgfSettings.flow.splashScreenDialog) {
            this.splashScreenDialog = new tgfSettings.flow.splashScreenDialog();
        }
        else {
            // 			this.splashScreenDialog = new tgfDialogs.SplashScreen();
        }
        this.splashScreenDialog.onHide = function (dialog) { self.currentAction = self.actionHideSplashScreen; };
        this.splashScreenDialog.show();
        tgfFramework._loadResources(["audio", "images"], ["audio", "images"]);
        this.currentAction = undefined;
    }
    else {
        this.currentAction = this.actionStartPlay;
    }
    ytgame.game.gameReady();
    youtubeMuteManager.updateMuteState();
    TimeCalculator.markEnd("total");
};
// Hide the splash screen
FlowController.prototype.actionHideSplashScreen = function () {
    "use strict";
    if (
    //this.initStates.analytics !== true ||
    this.initStates.inventory !== true ||
        this.initStates.tgFramework !== true ||
        this.initStates.levelRandomiser !== true ||
        this.initStates.friendManager !== true ||
        this.initStates.expManager !== true) {
        // delay progressing until everything is finished; it should have
        return;
    }
    // gameController.scheduleRetentionNotifications();
    // gameController.handleSuggestedFriendNotification();
    // leaderboardManager.init();
    TimeCalculator.print();
    TimeCalculator.sendAnalyticsEvents([
        "loader_done",
        "sdk_initialized",
        "tgfFramework",
        // "gamesBackendService",
        // "AnalyticsService",
        "actionStartLoadingResources",
        "inventoryController",
        "startGameAsync",
        "levelRandomizer",
        "total"
    ]);
    this.splashScreenDialog.hide();
    if (this.splashScreenDialog && this.splashScreenDialog.coolgamesBackground) {
        tgfGraphics.removeChild(this.splashScreenDialog.coolgamesBackground);
    }
    if (this.consentDialog && this.consentDialog.coolgamesBackground) {
        tgfGraphics.removeChild(this.consentDialog.coolgamesBackground);
    }
    this.splashScreenDialog.free();
    this.splashScreenDialog = undefined;
    this.currentAction = this.actionStartPlay;
};
// Start playing the games
FlowController.prototype.actionStartPlay = function () {
    "use strict";
    TimeCalculator.markEnd("loadingFinished");
    TimeCalculator.sendAnalyticsEvents(["loadingFinished"]);
    var contextType = tgfHooks.getContextType();
    AngryAnalytics.reportContext();
    // AngryAnalytics.reportAdvertisementSupport(adService.isRewardedAdsSupported(), adService.isInterstitialAdsSupported());
    if (_enableMaintenance) {
        _enableMaintenance();
        this.currentAction = undefined;
        return;
    }
    // this._backendService = gamesBackendService;
    var entrydata = tgfHooks.getEntryPointData();
    if (entrydata && entrydata["tag"]) {
        // gamesBackendService.getMatchesData([entrydata["id"]], ["levelSettings"], function(data) {
        // 	if(!data[entrydata["id"]] && entrydata["tag"]){
        // 		AngryAnalytics.reportClickEntry(entrydata["tag"]);
        // 	} else if (data[entrydata["id"]] && data[entrydata["id"]]["levelSettings"]) {
        // 		AngryAnalytics.reportClickEntry(entrydata["tag"], data[entrydata["id"]]["levelSettings"]["levelIndex"], entrydata["id"]);
        // 	} else {
        // 		AngryAnalytics.reportClickEntry(entrydata["tag"], entrydata["id"]);
        // 	}
        // });
    }
    if (!DailyRewardManager.hasClaimedRewardToday()) {
        var dialog = new DailyRewardDialog({
            onClose: this._handleInitialContext.bind(this)
        });
        dialog.show();
    }
    else {
        this._handleInitialContext();
    }
    this.currentAction = null;
};
FlowController.prototype._handleInitialContext = function () {
    var self = this;
    var contextType = tgfHooks.getContextType();
    if (!this.hasPlayedBefore) {
        gameController.startPlay({}, 0, false, true, false, null, function () { });
    }
    else {
        var isGroup = tgfHooks.isSizeBetween(3, null);
        if (contextType === "THREAD" && !isGroup) {
            gameController.resumeOrStartNewGame(null, null, function () {
                //no game can be resumed - show the lobby
                self.showLobby(true);
            }, true);
        }
        else {
            if (isGroup) {
                var groupMsg = NudgeFactory.GetPremadeNudge('update', 2, {});
                var localizations = NudgeFactory.GenerateCustomUpdateLocalization('GROUP_MSG_TEXT', [
                    tgfHooks.getPlayerName()
                ]);
                var CTAlocalizations = NudgeFactory.GenerateCustomUpdateLocalization('GROUP_MSG_CTA_TEXT');
                AngryAnalytics.reportGroupCustomMessages();
                tgfHooks.updateAsync(function () { }, "group", groupMsg, CTAlocalizations, localizations, { "tag": "group" });
            }
            this.showLobby(true);
        }
    }
};
FlowController.prototype.showLobby = function (showLoader) {
    var self = this;
    if (showLoader) {
        this.showLobbyLoader();
    }
    this._lobbyLoadTime = Date.now();
    this.getMatchList(function (data) {
        ExpManager.loadAllFriendRanks().then(function () {
            self.activateLobby(data);
            AngryAnalytics.reportLobbyLoadTime(Date.now() - self._lobbyLoadTime);
        });
    });
};
FlowController.prototype.getMatchList = function (callback) {
    var self = this;
    return callback([]);
};
FlowController.prototype.showLobbyLoader = function () {
    "use strict";
    this.lobbyLoader = new AngryLobbyLoader();
    this.lobbyLoader.show();
    AngryAnalytics.reportScreen("lobbyLoading");
    TimeCalculator.markStart("lobbyLoading");
};
FlowController.prototype.activateLobby = function (data) {
    "use strict";
    var self = this;
    FriendManager.setUnsuggestablePlayersFromMatchList(data);
    _currentFlowState = "lobby";
    if (this.lobbyLoader) {
        this.lobbyLoader.data = data;
        this.lobbyLoader.onLoadCallback = function (data) {
            self.lobbyLoader = null;
            self.activateLobby(data);
            TimeCalculator.markEnd("lobbyLoading");
            TimeCalculator.sendAnalyticsEvents([
                "lobbyLoading"
            ]);
        };
        this.lobbyLoader.isLoaded();
        return;
    }
    var musicID = null;
    if (this.lobbyScreenDialog && this.lobbyScreenDialog.musicID) {
        musicID = this.lobbyScreenDialog.musicID;
    }
    this.cachedLobbyData = data;
    flowController.freeLobby();
    if (tgfSettings.flow.lobbyScreenDialog) {
        this.lobbyScreenDialog = new tgfSettings.flow.lobbyScreenDialog({ musicID: musicID });
    }
    else {
        // 		this.lobbyScreenDialog = new tgfDialogs.DialogLobby();
    }
    if (this.lobbyScreenDialog) {
        if (Object.keys(data).length > 0) {
            profileManager.batchLoad(data, function () {
                self.lobbyScreenDialog.listMatches = data;
                self.lobbyScreenDialog.show();
                self.lobbyScreenDialog.updateMatildaProgress(true);
            });
        }
        else {
            this.lobbyScreenDialog.listMatches = data;
            this.lobbyScreenDialog.show();
            this.lobbyScreenDialog.updateMatildaProgress(true);
        }
    }
};
FlowController.prototype.freeLobby = function () {
    "use strict";
    var lobby = this.lobbyScreenDialog;
    if (lobby) {
        if (lobby.optionScreen) {
            lobby.optionScreen.hide();
            lobby.optionScreen.free();
            lobby.optionScreen = null;
        }
        if (lobby.gachaScreen) {
            tbGame.removeToken(lobby.gachaScreen);
            lobby.gachaScreen = null;
        }
        gameController.closeNewGameDialogs();
        if (lobby.notYourTurn) {
            lobby.notYourTurn.hide();
            lobby.notYourTurn.free();
            lobby.notYourTurn = null;
        }
        if (lobby.inputMask) {
            lobby.inputMask.hide();
            lobby.inputMask.free();
            lobby.inputMask = null;
        }
        lobby.hide();
        lobby.free();
        this.lobbyScreenDialog = null;
    }
};
// ***************************************
// Event handling methods
// ***************************************
FlowController.prototype.handleEndStep = function (timePassed) {
    "use strict";
    // Check whether the flow is paused
    if (this.paused > 0) {
        return;
    }
    // Perform the current action
    if (this.currentAction) {
        this.currentAction(timePassed);
    }
    if (this.adTimer > -1) {
        this.adTimer -= timePassed;
        //      console.log(this.adTimer);
    }
    if (this.lobbyScreenDialog && this.lobbyScreenDialog.decrementTimers) {
        this.lobbyScreenDialog.decrementTimers();
    }
};
FlowController.prototype.handleDraw = function () {
    "use strict";
    // Clear the dynamic canvasses
    tgfGraphics.clearDynamicCanvasses();
};
FlowController.prototype.getServerTime = function () {
    if (tgfSettings.enableDebugSettings) {
        return Date.now();
    }
    else {
        return this._serverTimeDiff + Date.now();
    }
};
FlowController.prototype.getLocalTime = function () {
    return this.getServerTime() + (new Date().getTimezoneOffset() * 1000 * 60) + (120 * 1000 * 60);
};
// ***************************************
// Create the flow object
// ***************************************
// Create the flow object
export var flowController = new FlowController();
